import "./PrecisionCare.module.css";
import Header from "@/reusable_sections/Header";
import PersonalizedMedicationManagement from "./sections/PersonalizedMedicationManagement";
import TheGeneticAdvantageBreakdown from "./sections/TheGeneticAdvantageBreakdown";
import CareForEveryStageOfLife from "./sections/CareForEveryStageOfLife";
import Footer from "@/reusable_sections/Footer";
export default function PrecisionCarePage() {
  return <div>
      <Header />
      <PersonalizedMedicationManagement />
      <TheGeneticAdvantageBreakdown />
      <CareForEveryStageOfLife />
      <Footer />
    </div>;
}